<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានអ្នកដឹកជញ្ជូន</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100 text-right">
					<span class="late">* តម្រូវឱ្យបំពេញ</span>
				</div>
				<div class="md-layout">
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>ឈ្មោះអ្នកដឹកជញ្ជូន *</label>
							<md-input type="text" v-model="driver.name"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>លេខទូរស័ព្អអ្នកដឹកជញ្ជូន *</label>
							<md-input type="text" v-model="driver.phone"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>ពាក្យសំងាត់ថ្មី *</label>
							<md-input type="password" v-model="driver.password">
							</md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>បញ្ជាក់ពាក្យសំងាត់ថ្មី *</label>
							<md-input type="password" v-model="driver.confirm_password">
							</md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>កំណត់ចំណាំផ្សេងៗ</label>
							<md-input type="text" v-model="driver.note">
							</md-input>
						</md-field>
					</div>
				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានសង្ខេប</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-table>
						<md-table-row>
							<md-table-cell style="width: 50%;">ឈ្មោះអ្នកដឹកជញ្ជូន</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell>
								<span v-if="String(driver.name).length > 0">{{driver.name}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>លេខទូរស័ព្ទ</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(driver.phone).length > 0">{{driver.phone}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>កំណត់ចំណាំ</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(driver.note).length > 0">{{driver.note}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
					</md-table>
				</div>
			</div>
			<div class="md-layout-item md-size-100 text-right">
				<md-button class="md-raised md-primary" @click="updateDriver()">កែប្រែ</md-button>
			</div>
		</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			// this.getTransaction();
			this.getDriver();
		},
		data() {
			return {
				tabName: "first",
				loaded: false,
				driver: {
					name: "",
					phone: "",
					password: "",
					confirm_password: "",
					old_password: "",
					note: ""
				}
			}
		},
		methods: {
			getDriver() {
				this.$http.get(this.config.api + '/admin/driver/get/' + this.$route.params.hash_id).then(data => {
					this.driver.id = data.body.data.id
					this.driver.name = data.body.data.name
					this.driver.phone = data.body.data.phone
					this.driver.note = data.body.data.note
					this.driver.old_password = data.body.data.password
					this.loaded = true
				})
			},
			checkValidation() {
				if (String(this.driver.name).length > 0 && String(this.driver.phone).length > 0) {
					if (String(this.driver.password) == String(this.driver.confirm_password)) {
						return true;
					} else {
						this.$notification.notify({
							message: "ពាក្យសំងាត់ និង បញ្ជាក់ពាក្យសំងាត់មិនដូចគ្នា។",
							icon: 'error',
							type: 'danger'
						})
					}
				} else {
					this.$notification.notify({
						message: "ព័ត៌មានមិនគ្រប់ សូមពិនិត្យមើលម្តងទៀត។",
						icon: 'error',
						type: 'danger'
					})
					return false;
				}
			},
			updateDriver() {
				if (this.checkValidation()) {
					this.$http.post(this.config.api + "/admin/driver/update", {
						driver: this.driver
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "អ្នកដឹកជញ្ជូនត្រូវបានកែប្រែដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.clear();
							this.$router.push("/drivers");

						}
					})
				}
			},
			clear() {
				this.driver = {
					name: "",
					phone: "",
					password: "",
					confirm_password: "",
					note: ""
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Drivers/Edit.vue